export function hasInvalidFromAsset(order, fromAsset): fromAsset is undefined {
  return order && !fromAsset;
}
